import React, { useState } from 'react';
import { Nav, Row, Col, Tab } from 'react-bootstrap';
import styled from 'styled-components';
import ProductsManagementTab from './products-management-tab';
import UnitsManagementTab from './units-management-tab';
import ConcentrateCompoundsManagementTab from './concentrate-compunds-management-tab';
import UnionsManagementTab from './unions-management-tab';
import { HDivider } from 'components/CommonWidgets';

const MainCard = styled.div`
	background-color: white;
	position: relative;
	border-radius: 26px;
	margin: 1rem 0 0 1rem;
`;

const TabsCard = styled.div`
	background-color: white;
	margin: 0 auto;
	border-radius: 26px;
`;

const TabColumn = styled(Col)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
        color: black;
        font-weight: 900;
        font-size: 14pt;
    }
`;

const TabLine = styled.div`
	width: 10em;
	height: 0.5rem;
	background-color: #0278ee;
	border-top-left-radius: 11px;
	border-top-right-radius: 11px;
`;

const TabContent = styled(Tab.Content)`
    width: 100%;
    margin: 2rem 0 3rem 0;
    transition: all 500ms ease-in-out;
`;

const PageTitle = styled.div`
	color: white;
	font-size: 18pt;
	font-weight: 700;
	text-align: end;
`;

const Information = () => {
	const [ currentTab, setCurrentTab ] = useState('products-management');

	return (
		<div>
			<Row className="mt-2">
				<PageTitle>اطلاعات پایه</PageTitle>
			</Row>
			<MainCard>
				<Tab.Container defaultActiveKey={currentTab} onSelect={(k) => setCurrentTab(k)}>
					<TabsCard className="pt-4">
						<Nav>
							<Row className="w-100">
								<TabColumn md={3}>
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'unions-management-tab'}>مدیریت اتحادیه ها</Nav.Link>
									</Nav.Item>
									{currentTab === 'unions-management-tab' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'concentrate-compounds-management'}>مدیریت ترکیبات کنسانتره</Nav.Link>
									</Nav.Item>
									{currentTab === 'concentrate-compounds-management' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'units-management'}>مدیریت واحد های سنجش</Nav.Link>
									</Nav.Item>
									{currentTab === 'units-management' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'products-management'}>مدیریت اقلام</Nav.Link>
									</Nav.Item>
									{currentTab === 'products-management' && <TabLine />}
								</TabColumn>
							</Row>
							<HDivider />
						</Nav>
					</TabsCard>
					<Row>
						<TabContent>
							<Tab.Pane eventKey="products-management">
								<ProductsManagementTab currentTab={currentTab} />
							</Tab.Pane>
							<Tab.Pane eventKey="units-management">
								<UnitsManagementTab currentTab={currentTab} />
							</Tab.Pane>
							<Tab.Pane eventKey="concentrate-compounds-management">
								<ConcentrateCompoundsManagementTab currentTab={currentTab} />
							</Tab.Pane>
							<Tab.Pane eventKey="unions-management-tab">
								<UnionsManagementTab currentTab={currentTab} />
							</Tab.Pane>
						</TabContent>
					</Row>
				</Tab.Container>
			</MainCard>
		</div>
	);
};

export default Information;
